"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPrice = exports.getNumber = exports.toNumber = exports.isNumber = void 0;
function isNumber(value) {
    // eslint-disable-next-line no-restricted-globals
    return !isNaN(Number(value));
}
exports.isNumber = isNumber;
function toNumber(value) {
    if (value === undefined || !isNumber(value)) {
        return undefined;
    }
    return Number(value);
}
exports.toNumber = toNumber;
function getNumber(value) {
    if (value === void 0) { value = ""; }
    var result = /([1-9][\d]*|0)(\.[\d]+)?/.exec(value);
    if (!result || result.length === 0) {
        return undefined;
    }
    return toNumber(result[0]);
}
exports.getNumber = getNumber;
// 价格处理
var setPrice = function (realPrice, originalPrice) {
    var realPriceArr = realPrice
        ? "".concat(Number(realPrice).toFixed(2)).split(".")
        : ["0", "00"];
    var originalPriceStr = "";
    if (originalPrice && originalPrice !== realPrice) {
        originalPriceStr = "\u00A5".concat(originalPrice);
    }
    return {
        real: realPriceArr, // 实际价格
        original: originalPriceStr, // 原价
    };
};
exports.setPrice = setPrice;
